import apiClient from "@/axiosConfig";
import { useUxStore } from "@/stores/uxStore";

const getUxStore = () => useUxStore();

export default {
  async copyGroup(id, name, confirmedAssignmentIds) {
    try {
      getUxStore().startLoading();
      return await apiClient.post(`/admin/groups/${id}/copy`, { name, confirmedAssignmentIds });
    } catch (error) {
      getUxStore().setError("Fehler beim Kopieren. Bitte Quelle und Berechtigungen erneut prüfen.");
      throw error;
    } finally {
      getUxStore().stopLoading();
    }
  },

  async getGroups(companyId = null) {
    try {
      getUxStore().startLoading();
      const params = {};
      if (companyId) params.companyId = companyId;
      return await apiClient.get("/admin/groups", { params });
    } catch (error) {
      console.error("Error in AdminGroupService.getGroups:", error);
      getUxStore().setError("Fehler beim Laden der Gruppen.");
      throw error;
    } finally {
      getUxStore().stopLoading();
    }
  },

  async createGroup({ companyId = null, name, description = null }) {
    try {
      getUxStore().startLoading();
      return await apiClient.post("/admin/groups", { companyId, name, description });
    } catch (error) {
      console.error("Error in AdminGroupService.createGroup:", error);
      getUxStore().setError("Fehler beim Erstellen der Gruppe.");
      throw error;
    } finally {
      getUxStore().stopLoading();
    }
  },

  async getGroupById(id) {
    try {
      getUxStore().startLoading();
      return await apiClient.get(`/admin/groups/${id}`);
    } catch (error) {
      console.error("Error in AdminGroupService.getGroupById:", error);
      getUxStore().setError("Fehler beim Laden der Gruppe.");
      throw error;
    } finally {
      getUxStore().stopLoading();
    }
  },

  async setGroupUsers(id, userIds) {
    try {
      getUxStore().startLoading();
      return await apiClient.put(`/admin/groups/${id}/users`, { ids: userIds || [] });
    } catch (error) {
      console.error("Error in AdminGroupService.setGroupUsers:", error);
      getUxStore().setError("Fehler beim Speichern der Gruppenbenutzer.");
      throw error;
    } finally {
      getUxStore().stopLoading();
    }
  },

  async setGroupRoles(id, roleIds) {
    try {
      getUxStore().startLoading();
      return await apiClient.put(`/admin/groups/${id}/roles`, { ids: roleIds || [] });
    } catch (error) {
      console.error("Error in AdminGroupService.setGroupRoles:", error);
      getUxStore().setError("Fehler beim Speichern der Gruppenrollen.");
      throw error;
    } finally {
      getUxStore().stopLoading();
    }
  },

  async deleteGroup(id) {
    try {
      getUxStore().startLoading();
      return await apiClient.delete(`/admin/groups/${id}`);
    } catch (error) {
      console.error("Error in AdminGroupService.deleteGroup:", error);
      getUxStore().setError("Fehler beim Löschen der Gruppe.");
      throw error;
    } finally {
      getUxStore().stopLoading();
    }
  },
};
